import styled from 'styled-components'
import L from '../L'

const layoutStyles = theme => ({
  root: {
    margin: 0,
    padding: 0,
    width: '100%',
    minHeight: '100vh',
    transition: theme.mixins.transition(['background-color']),
  },
  appBarWrapper: {
    height: 50,
  },
  appBarWrapperAutohide: {
    height: 'auto',
  },
  appBar: {
    '&.autohide::after': {
      content: "''",
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  fdxLogo: {
    height: 25,
    marginRight: theme.spacing(1.5),
    ...theme.mixins.l_responsiveImage,
  },
  l_breadcrumbs: {
    flex: 1,
    userSelect: 'none',
  },
  breadcrumbLink: {
    color: theme.palette.secondary.contrastText,
    fontWeight: theme.fontWeight.semibold,
    borderBottom: '1px solid transparent',
    transition: theme.globals.transitionFast,
    '&:hover': {
      borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
    },
  },
  breadcrumbLinkCurrent: {
    fontWeight: theme.fontWeight.semibold,
    opacity: 0.5,
  },
})

const MainContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  transition: ${props => props.theme.mixins.transition(['background-color'])};

  *:focus {
    outline-width: 3px;
    outline-style: solid;
    outline-color: #005ecc;
  }

  ${props =>
    !props.allowOutline
      ? `
  * {
    outline: none !important;
  }
`
      : ''}
`

const SlickDot = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 10px;
  cursor: pointer;
  background-color: ${props => props.theme.palette.background.secondary};
  transition: ${props => props.theme.mixins.transition(['background-color'])};
  &:hover {
    background-color: ${props => props.theme.palette.primary.main};
  }
  ${props => props.active && `background-color: ${props.theme.palette.primary.main};`}
`

const SlickArrow = styled(L).attrs({
  display: 'grid',
  ai: 'center',
  selectable: true,
})`
  color: ${props => props.theme.palette.primary.main};
  transition: ${props => props.theme.mixins.transition(['color', 'opacity', 'visibility'])};
  ${props =>
    props.hide &&
    `
    opacity: 0;
    visibility: hidden;
  `}
`

const CenteringDiv = styled.div`
  display: flex;
  justify-content: center;
`

export { MainContainer, SlickDot, SlickArrow, CenteringDiv, layoutStyles }
